import { AlertsRequestStoreModel } from '@domain/alerting/alerting.models';
import { EvseDetailsResponseStoreModel } from '@domain/single-site/single-site.models';

export const createActiveAlertsRequest = (evseDetails: EvseDetailsResponseStoreModel): AlertsRequestStoreModel => ({
  chargerIds: [evseDetails.chargerId],
  evseIds: [evseDetails.evseId],
  ...(evseDetails.vehicleUUID ? { vehicleIds: [evseDetails.vehicleUUID] } : {}),
});
